import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const WizardFooterContext = /*#__PURE__*/createContext(undefined);
export const WizardFooterProvider = ({
  footerStyleOverrides,
  children
}) => {
  const value = useMemo(() => ({
    footerStyleOverrides
  }), [footerStyleOverrides]);
  return /*#__PURE__*/_jsx(WizardFooterContext.Provider, {
    value: value,
    children: children
  });
};

/**
 * Provides the context for the `WizardFooter` component.
 * Note: The context is only available when the `WizardFooter` component is rendered as an ancestor.
 * @returns WizardFooterContext - The context for the `WizardFooter` component.
 * @returns WizardFooterContext.footerStyleOverrides - CSS overrides to apply to the `DialogFooter` component.
 */
export const useWizardFooterContext = () => {
  return useContext(WizardFooterContext);
};